export const USER_TAGS = [
	{ id: 'coffee', name: '☕️ За кофе' },
	{ id: 'gratitude', name: '🤝 Спасибо' },
	{ id: 'review', name: '💻 За код-ревью' },
	{ id: 'birthday', name: '🎁 С Днем Рождения!' },
	{ id: 'lunch', name: '🥗 За обед' },
]

export const CFO_TAGS = [
	{ id: 'team', name: '🤝 За командный дух' },
	{ id: 'lead', name: '🏆 За лидерство' },
	{ id: 'target', name: '🎯 За достижение целей' },
	{ id: 'ideas', name: '🚀 За новаторские идеи' },
]

export const USER_INCOME = [
	{ id: 'transactions', value: 250, label: 'Переводы' },
	{ id: 'encouragement', value: 150, label: 'Начисления из бюджета' },
	{ id: 'gifts', value: 100, label: 'Подарки' },
	{ id: 'activity', value: 100, label: 'Активности' },
]

export const USER_EXPENSES = [
	{ id: 'market', value: 10, label: 'Магазин' },
	{ id: 'activity', value: 20, label: 'Активности' },
	{ id: 'gifts', value: 30, label: 'Подарки' },
	{ id: 'transactions', value: 40, label: 'Переводы' },
]

/* ----------- История операций ----------- */
export const HISTORY_PURPOSES = {
	encouragement: 'Начисление из бюджета',
	market: 'Покупка в маркете',
	transactions: 'Перевод пользователю',
	activity: 'Участие в активностях',
	gifts: 'Подарок',
	budget: 'Распределение бюджета',
}

export const USER_HISTORY = [
	{
		operation_type: 'expense',
		purpose_id: 'transactions',
		from_account_number: '1000000000',
		to_account_number: '1000000001',
		amount: 40,
		payment_comment: '👾 За релиз без багов',
		datetime: '2025-11-19T18:47:56+05:00',
	},
	{
		operation_type: 'income',
		purpose_id: 'transactions',
		from_account_number: '1000000000',
		to_account_number: '1000000004',
		amount: 250,
		payment_comment: '💻 Крутому разработчику :)',
		datetime: '2025-05-05T15:45:30+05:00',
	},
	{
		operation_type: 'expense',
		purpose_id: 'market',
		from_account_number: '1000000000',
		amount: 10,
		payment_comment: 'Футболка с логотипом Т1',
		datetime: '2025-04-25T18:47:56+05:00',
	},
	{
		operation_type: 'expense',
		purpose_id: 'gifts',
		from_account_number: '1000000000',
		to_account_number: '1000000002',
		amount: 30,
		payment_comment: '🌺 Поздравляю с 8 марта!',
		datetime: '2025-03-08T12:40:50+05:00',
	},
	{
		operation_type: 'income',
		purpose_id: 'encouragement',
		from_account_number: '1000000000',
		to_account_number: '1000000001',
		amount: 150,
		payment_comment: '🚀 За выдающиеся результаты работы!',
		datetime: '2024-12-27T16:30:12+05:00',
	},
	{
		operation_type: 'expense',
		purpose_id: 'activity',
		from_account_number: '1000000000',
		amount: 20,
		payment_comment: 'Участие в квизе',
		datetime: '2024-11-20T15:40:56+05:00',
	},
	{
		operation_type: 'income',
		purpose_id: 'gifts',
		from_account_number: '1000000000',
		to_account_number: '1000000005',
		amount: 100,
		payment_comment: '🎁 С Днем Рождения!',
		datetime: '2024-10-25T11:50:09+05:00',
	},
	{
		operation_type: 'income',
		purpose_id: 'activity',
		from_account_number: '1000000000',
		to_account_number: '1000000002',
		amount: 100,
		payment_comment: 'Участие в ИТ-лагере Т1 2024',
		datetime: '2024-08-31T18:40:07+05:00',
	},
]

export const CFO_HISTORY = [
	// 8 команд - распределение средств
	{
		operation_type: 'expense',
		purpose_id: 'transactions',
		from_account_number: '2000000000',
		to_account_number: '1000000001',
		amount: 40,
		payment_comment: 'За высокие показатели работы!',
		datetime: '2025-11-19T12:50:56+05:00',
	},
	{
		operation_type: 'income',
		purpose_id: 'encouragement',
		from_account_number: '3000000000',
		to_account_number: '2000000000',
		amount: 15600,
		payment_comment: 'Пополнение ЦФО администратором',
		datetime: '2025-07-01T09:12:56+05:00',
	},
]

export const ADMIN_HISTORY = [
	{
		operation_type: 'income',
		purpose_id: 'encouragement',
		amount: 163700,
		payment_comment: 'Пополнение мастер счета администратором',
		datetime: '2024-08-31T17:53:56+05:00',
	},
]

/* ----------- Список получаталей ----------- */
export const EMPLOYEE_LIST = [
	{
		id: 1,
		username: 'PIvanov',
		surname: 'Иванов',
		name: 'Петр',
		lastname: 'Сергеевич',
		account_number: '1000000001',
		email: 'PIvanov@example.ru',
		position: 'Руководитель направления разработки',
		department: 'Департамент цифровизации бизнеса',
		full_name: 'Иванов Петр Сергеевич',
		short_name: 'Иванов П.С.',
	},
	{
		id: 2,
		username: 'MPopova',
		surname: 'Попова',
		name: 'Мария',
		lastname: 'Александровна',
		account_number: '1000000002',
		email: 'MPopova@example.ru',
		position: 'Руководитель группы тестирования',
		department: 'Департамент облачных решений',
		full_name: 'Попова Мария Александровна',
		short_name: 'Попова М.А.',
	},
	{
		id: 3,
		username: 'IBerezin',
		surname: 'Березин',
		name: 'Иван',
		lastname: 'Алексеевич',
		account_number: '1000000003',
		email: 'IBerezin@example.ru',
		position: 'Руководитель проекта',
		department: 'Департамент управления рисками',
		full_name: 'Березин Иван Алексеевич',
		short_name: 'Березин И.А.',
	},
	{
		id: 4,
		username: 'AVoronin',
		surname: 'Воронин',
		name: 'Александр',
		lastname: 'Сергеевич',
		account_number: '1000000004',
		email: 'AVoronin@example.ru',
		position: 'Руководитель подразделения',
		department: 'Департамент инновационных исследований',
		full_name: 'Воронин Александр Сергеевич',
		short_name: 'Воронин А.С.',
	},
	{
		id: 5,
		username: 'EVetrova',
		surname: 'Ветрова',
		name: 'Екатерина',
		lastname: 'Александровна',
		account_number: '1000000005',
		email: 'EVetrova@example.ru',
		position: 'Руководитель направления разработки',
		department: 'Департамент продуктовых исследований',
		full_name: 'Ветрова Екатерина Александровна',
		short_name: 'Ветрова Е.А.',
	},
]

/* ----------- Аналитика ----------- */
export const CFO_TEAM_LIST = [
	{
		id: '1',
		name: 'Кузнецов Д.М.',
		position: 'Lead QA Engineer',
		teamId: 'team_qa',
		team: 'Команда QA',
		expenses: 160,
	},
	{
		id: '2',
		name: 'Захарова К.А.',
		position: 'Head of Product',
		teamId: 'team_product',
		team: 'Команда Product',
		expenses: 210,
	},
	{
		id: '3',
		name: 'Петров И.И.',
		position: 'Senior Frontend Developer',
		teamId: 'team_frontend',
		team: 'Команда Frontend',
		expenses: 180,
	},
	{
		id: '4',
		name: 'Орлов Д.С.',
		position: 'Data Science Lead',
		teamId: 'team_data',
		team: 'Команда Data',
		expenses: 360,
	},
	{
		id: '5',
		name: 'Воробьева О.Л.',
		position: 'Senior iOS Developer',
		teamId: 'team_mobile',
		team: 'Команда Mobile',
		expenses: 115,
	},
	{
		id: '6',
		name: 'Морозова И.Г.',
		position: 'Senior QA Engineer',
		teamId: 'team_qa',
		team: 'Команда QA',
		expenses: 140,
	},
	{
		id: '7',
		name: 'Федорова А.С.',
		position: 'Lead UX/UI Designer',
		teamId: 'team_design',
		team: 'Команда Design',
		expenses: 155,
	},
	{
		id: '8',
		name: 'Иванова Е.С.',
		position: 'Senior Backend Developer',
		teamId: 'team_backend',
		team: 'Команда Backend',
		expenses: 190,
	},
	{
		id: '9',
		name: 'Сидоров А.А.',
		position: 'Middle Frontend Developer',
		teamId: 'team_frontend',
		team: 'Команда Frontend',
		expenses: 140,
	},
	{
		id: '10',
		name: 'Филиппова Н.В.',
		position: 'Senior DevOps Engineer',
		teamId: 'team_devops',
		team: 'Команда DevOps',
		expenses: 165,
	},
	{
		id: '11',
		name: 'Новиков Р.П.',
		position: 'Senior Android Developer',
		teamId: 'team_mobile',
		team: 'Команда Mobile',
		expenses: 180,
	},
	{
		id: '12',
		name: 'Белов А.Н.',
		position: 'Senior Product Manager',
		teamId: 'team_product',
		team: 'Команда Product',
		expenses: 175,
	},
	{
		id: '13',
		name: 'Краснова П.А.',
		position: 'Junior Frontend Developer',
		teamId: 'team_frontend',
		team: 'Команда Frontend',
		expenses: 190,
	},
	{
		id: '14',
		name: 'Григорьев М.П.',
		position: 'Senior ML Engineer',
		teamId: 'team_data',
		team: 'Команда Data',
		expenses: 235,
	},
	{
		id: '15',
		name: 'Лебедева Т.К.',
		position: 'Middle Mobile Developer',
		teamId: 'team_mobile',
		team: 'Команда Mobile',
		expenses: 135,
	},
	{
		id: '16',
		name: 'Павлова Л.М.',
		position: 'Senior Data Analyst',
		teamId: 'team_data',
		team: 'Команда Data',
		expenses: 260,
	},
	{
		id: '17',
		name: 'Волков С.Д.',
		position: 'Automation QA',
		teamId: 'team_qa',
		team: 'Команда QA',
		expenses: 130,
	},
	{
		id: '18',
		name: 'Сидоров А.Н.',
		position: 'Frontend Tech Lead',
		teamId: 'team_frontend',
		team: 'Команда Frontend',
		expenses: 110,
	},
	{
		id: '19',
		name: 'Васильев В.В.',
		position: 'Middle Backend Developer',
		teamId: 'team_backend',
		team: 'Команда Backend',
		expenses: 150,
	},
	{
		id: '20',
		name: 'Данилов П.О.',
		position: 'Data Scientist',
		teamId: 'team_data',
		team: 'Команда Data',
		expenses: 220,
	},
]

export const ADMIN_TEAM_LIST = [
	{
		id: '2000000007',
		name: 'Стрим 7',
		owner: 'Клинов Д.Н.',
		owner_full_name: 'Клинов Дмитрий Николаевич',
		owner_position: 'Руководитель подразделения',
		owner_department: 'Департамент развития бизнеса',
		owner_email: 'DKlimov@example.ru',
		account_number: '2000000007',
		balance: 5800,
		income: 7000,
		expenses: 1200,
	},
	{
		id: '2000000009',
		name: 'Стрим 9',
		owner: 'Семенов Д.А.',
		owner_full_name: 'Семенов Дмитрий Александрович',
		owner_position: 'Руководитель группы тестирования',
		owner_department: 'Департамент обеспечения качества',
		owner_email: 'DSemenov@example.ru',
		account_number: '2000000009',
		balance: 160,
		income: 2000,
		expenses: 1840,
	},
	{
		id: '2000000010',
		name: 'Стрим 10',
		owner: 'Солнцев В.Л.',
		owner_full_name: 'Солнцев Владимир Леонидович',
		owner_position: 'Руководитель направления разработки',
		owner_department: 'Департамент облачных решений',
		owner_email: 'VSolntsev@example.ru',
		account_number: '2000000010',
		balance: 600,
		income: 8000,
		expenses: 7400,
	},
	{
		id: '2000000012',
		name: 'Стрим 12',
		owner: 'Сидоров А.Н.',
		owner_full_name: 'Сидоров Андрей Николаевич',
		owner_position: 'Руководитель подразделения',
		owner_department: 'Департамент развития бизнеса',
		owner_email: 'ASidorov@example.ru',
		account_number: '2000000012',
		balance: 1201,
		income: 9000,
		expenses: 7799,
	},
	{
		id: '2000000015',
		name: 'Стрим 15',
		owner: 'Романов А.И.',
		owner_full_name: 'Романов Алексей Иванович',
		owner_position: 'Руководитель направления разработки',
		owner_department: 'Департамент облачных решений',
		owner_email: 'ARomanov@example.ru',
		account_number: '2000000015',
		balance: 500,
		income: 2000,
		expenses: 1500,
	},
	{
		id: '2000000019',
		name: 'Стрим 19',
		owner: 'Лаврова Л.Д.',
		owner_full_name: 'Лаврова Любовь Дмитриевна',
		owner_position: 'Руководитель направления разработки',
		owner_department: 'Департамент облачных решений',
		owner_email: 'LLavrove@example.ru',
		account_number: '2000000019',
		balance: 9900,
		income: 19000,
		expenses: 9100,
	},
	{
		id: '2000000020',
		name: 'Стрим 20',
		owner: 'Петров И.И.',
		owner_full_name: 'Петров Игорь Иванович',
		owner_position: 'Руководитель группы тестирования',
		owner_department: 'Департамент обеспечения качества',
		owner_email: 'IPetrov@example.ru',
		account_number: '2000000020',
		balance: 7550,
		income: 15000,
		expenses: 7450,
	},
	{
		id: '2000000025',
		name: 'Стрим 25',
		owner: 'Краснов С.П.',
		owner_full_name: 'Краснов Сергей Петрович',
		owner_position: 'Руководитель подразделения',
		owner_department: 'Департамент продуктовых исследований',
		owner_email: 'SKrasnov@example.ru',
		account_number: '2000000025',
		balance: 2410,
		income: 10000,
		expenses: 7590,
	},
	{
		id: '2000000031',
		name: 'Стрим 31',
		owner: 'Титов С.П.',
		owner_full_name: 'Титов Семен Петрович',
		owner_position: 'Руководитель подразделения',
		owner_department: 'Департамент продуктовых исследований',
		owner_email: 'STitov@example.ru',
		account_number: '2000000031',
		balance: 100,
		income: 1000,
		expenses: 900,
	},
]
